var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCeremony(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.165 32C15.7955 29.8684 14.3845 28.7491 13.0081 27.6297C11.4086 26.3295 9.67321 25.2667 8.02868 24.042C6.03121 22.5549 4.10809 20.9659 2.6971 18.7066C1.30638 16.4808 0.879857 13.9703 1.02779 11.3048C1.15019 9.11324 1.77496 7.12481 2.99897 5.39521C4.36716 3.46162 6.15361 2.46655 8.29376 2.2437C9.97733 2.06886 11.6106 2.28313 13.1583 3.11622C14.0789 3.61247 14.8884 4.27328 15.5334 5.17665C15.6964 5.40378 15.8 5.48263 15.9802 5.19465C17.2178 3.22164 18.9704 2.29256 21.0287 2.06371C23.4069 1.79888 25.6469 2.34398 27.5768 3.99387C29.6411 5.75775 30.6916 8.22873 30.956 11.1188C31.2436 14.2592 30.0901 16.8664 28.4344 19.22C26.8582 21.4604 24.8517 23.166 22.8347 24.8442C21.3178 26.1067 19.7612 27.3066 18.3284 28.6959C17.3912 29.607 16.5457 30.591 16.165 32Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeremony);
export default __webpack_public_path__ + "static/media/ceremony.ae47503d144dab9f6dd028b8d03723d5.svg";
export { ForwardRef as ReactComponent };